export default __webpack_public_path__ + "static/media/relatorios-avancados-web.4244ac0a.png";